/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentCompanies.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Company API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 5:05 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Companies = {
  all: companystatusid => requests.get(`/Companies?companystatusid=${companystatusid ? companystatusid : 0}`),
  get: companyid => requests.get(`/Company/${companyid}`),
  create: company => requests.post(`/Companies`, company),
  update: (companyid, company) => requests.put(`/Company/${companyid}`, company),
  delete: companyid => requests.del(`/Company/${companyid}`),
};

export const CompanyStatuses = {
  all: () => requests.get('/CompanyStatuses'),
  get: companystatusid => requests.get(`/CompanyStatus/${companystatusid}`),
  create: companystatus => requests.post(`/CompanyStatuses`, companystatus),
  update: (companystatusid, companystatus) => requests.put(`/CompanyStatus/${companystatusid}`, companystatus),
  delete: companystatusid => requests.del(`/CompanyStatus/${companystatusid}`),
};